/**
 * 生产环境配置文件
 * 如果程序开发过程中需要增加参数，请同步更新该文件
 */
// 智盈php接口域名
export const API_HOST = 'http://huaijiugf.guotaijiu.com/'
export const API_HOST_JAVA = 'http://huaijiugf.guotaijiu.com/v2/'
// 智盈java版接口域名
export const API_HOST_JAVA_SET = 'http://huaijiugf.guotaijiu.com/v2/'
export const API_IMG_HOST = 'http://huaijiugf.guotaijiu.com/'
export const CDN_IMG_HOST = 'http://member.intelliquor.com/'
export const YZ_HOST = 'http://center.intelliquor.com/'
export const YZ_HOST_API = 'http://yz.intelliquor.com/'
export const YT_HOST_API = 'http://yt.baijiuyun.com/'
// 大后台接口域名
export const DHT_HOST_API = 'http://huaijiugf.guotaijiu.com/manage'
// 布奖前端
export const FRONTEND_MARKET_URL = 'http://huaijiuszhqd.guotaijiu.com/market/'
// 会员中心前端
export const FRONTEND_MEMBER_URL = 'http://huaijiuszhqd.guotaijiu.com/member/'
// 云店
export const YD_HOST_API = 'http://huaijiuszhqd.guotaijiu.com/cloudshop/goods/goods'
// 云商
export const YS_HOST_API = 'http://huaijiuszhqd.guotaijiu.com/clouddealer/'
// 云销
export const YX_HOST_API = 'http://huaijiuszhqd.guotaijiu.com/cloudsalesman/'
// 品鉴酒
export const FRONTEND_WINE_URL = 'http://huaijiuszhqd.guotaijiu.com/savourwine/'
// 饮酒顾问
export const YINJIU_GUWEN = 'http://huaijiuszhqd.guotaijiu.com/drinkadvisory/'
// 领袖会
export const LX_HY_URL = 'http://huaijiuszhqd.guotaijiu.com/clouddealer/'
// 饮酒联盟
export const YJ_LM_URL = 'http://huaijiuszhqd.guotaijiu.com/cloudshop/goods/goods'
// 国粉俱乐部
export const GUOFEN_CLUB_URL = 'http://huaijiuszhqd.guotaijiu.com/drinkclub/'
// 国台封坛
export const GUOTAI_FENGTAN = 'http://huaijiuszhqd.guotaijiu.com/guotaisealaltar/'
// 终端管理
export const ZD_GL_URL = 'http://huaijiuszhqd.guotaijiu.com/terminal'
// 应用服务菜单区分正式环境，测试环境
export const ENVCONFIG = 'prod'

export const IMAGE_LOGIN_LEFT = 'static/img/huaijiu/loginLeft.gif'
export const IMAGE_LOGIN_LOGO = 'static/img/huaijiu/logo.png'
export const LOGIN_TITLE = '怀酒数字营销平台管理后台'